import React, { useEffect } from "react";

import { Spinner } from "react-bootstrap";

import { S3_URL } from "common/constants/apiUrls";
import { useTranslation } from "react-i18next";

const Step3 = ({
  formik,
  productList = [],
  handleBack,
  handleNext,
  handleError,
  loading,
  handleCompletion,
}) => {
  const { t } = useTranslation();
  const STEP_ID = 3;
  useEffect(() => {
    handleError(STEP_ID, false);
    handleCompletion(STEP_ID, true);  
  }, []);
  return (
    <div className="d-flex flex-column justify-content-between h-100">
      <p className="mt-3">{t("product-access-text")}</p>
      {productList.map((el, index, arr) => (
        <>
          <div className="  d-flex">
            <img src={`/assets/icons${el.imageUrl}`} width={30} height={30} />
            <div className="d-flex w-100 justify-content-between align-items-start">
              <p className="px-2">{el.translatedValue}</p>
              <input
                className="checkbox-input"
                type="checkbox"
                aria-label="checkbox 1"
                name={el.productName}
                checked={formik.values[el.productName]}
                // onClick={() => {
                //   formik.setFieldValue(
                //     el.productName,
                //     !formik.values[el.productName]
                //   );
                // }}
                onClick={formik.handleChange}
              />
            </div>
          </div>

          <hr className="horizentalLine" />
        </>
      ))}

      <div className="d-flex justify-content-end align-items-center mt-5">
        <button
          className="parentbtn"
          style={{
            padding: "10px 35px",
            marginRight: "15px",
            backgroundColor: "gray",
          }}
          onClick={handleBack}
        >
          {t("back")}
        </button>
        {/* <button
          className="parentbtn "
          style={{ padding: "10px 35px" }}
          onClick={handleNext}
        >
          {t("next")}
        </button> */}
        <button
          type="submit"
          className="parentbtn "
          style={{ padding: "10px 35px" }}
        >
          {loading ? <Spinner animation="border" size="sm" /> : t("add-branch")}
        </button>
      </div>
    </div>
  );
};

export default Step3;
